/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S14_HeadingInputs */

const tr_kullanim_s14_heading = /** @type {(inputs: Kullanim_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Hesabın Askıya Alınması`)
};

const en_kullanim_s14_heading = /** @type {(inputs: Kullanim_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Suspension of the account`)
};

const de_kullanim_s14_heading = /** @type {(inputs: Kullanim_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Sperrung des Kontos`)
};

const ru_kullanim_s14_heading = /** @type {(inputs: Kullanim_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Приостановление учётной записи`)
};

/**
* | output |
* | --- |
* | "14. Suspension of the account" |
*
* @param {Kullanim_S14_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s14_heading = /** @type {((inputs?: Kullanim_S14_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S14_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s14_heading(inputs)
	if (locale === "de") return de_kullanim_s14_heading(inputs)
	if (locale === "ru") return ru_kullanim_s14_heading(inputs)
	return tr_kullanim_s14_heading(inputs)
});